import React, { useEffect } from "react";
import { Form, Button } from 'semantic-ui-react';
import { useForm } from "react-hook-form";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useNavigate, useLocation } from "react-router-dom";
import { HTTPURL, REQUEST_OPTIONS } from "../constants/matcher";
// import {AttemptLogin} from "../Utils/LoginLogout";
import {Child} from "../Utils/Child";

import {useRef} from 'react';

const AdminLogin = () => {
    const childRef = useRef(null);
    // const navigate = useNavigate();
    // const location = useLocation();

    const {
        register,
        handleSubmit,
        formState: { errors },
        reset
    } = useForm();

    const onSubmit = (data) => {
        childRef.current.login(data, 'admin');
    }

    return (
        <>
            <Child ref={childRef} />
            <div id="layoutAuthentication">
                <div id="layoutAuthentication_content">
                    <main>
                        <div className="container">
                            <div className="row justify-content-center">
                                <div className="col-lg-5">
                                    <div className="card shadow-lg border-0 rounded-lg mt-5">
                                        <div className="card-header"><h3 className="text-center font-weight-light my-4">Login</h3></div>
                                        <div className="card-body">
                                            <Form onSubmit={handleSubmit(onSubmit)}>
                                                <div className="card-body p-md-5 text-black">
                                                    <h3 className="mb-5 text-uppercase">Admin Login</h3>

                                                    <div className="form-outline mb-4">
                                                        <Form.Field>
                                                            <label className="form-label" htmlFor="Email Address">Email Address</label>
                                                            <input
                                                                placeholder='Email Address'
                                                                type="email"
                                                                {...register("email",
                                                                    {
                                                                        required: true,
                                                                        pattern: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                                                                    })}
                                                                className="form-control form-control-lg"
                                                            />
                                                        </Form.Field>
                                                        {errors.email && errors.email.type === "required" && <span className="validation-error">This is required</span>}
                                                        {errors.email && errors.email.type === "pattern" && <span className="validation-error">Must be a valid email</span>}
                                                    </div>

                                                    <div className="form-outline mb-4">
                                                        <Form.Field>
                                                            <label className="form-label" htmlFor="Password">Password</label>
                                                            <input
                                                                placeholder='Password'
                                                                type="password"
                                                                {...register("password", {
                                                                    required: true,
                                                                    pattern: /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{6,15}$/
                                                                })}
                                                                className="form-control form-control-lg"
                                                            />
                                                        </Form.Field>
                                                        {errors.password && errors.password.type === "required" && <span className="validation-error">This is required</span>}
                                                        {errors.password && errors.password.type === "pattern" && <span className="validation-error">At least 6 chars long,digit,upper case,lower case</span>}
                                                    </div>
                                                    
                                                    <div className="d-flex justify-content-end pt-3">
                                                    <Button type="button" className="btn btn-light btn-lg sap-btn-light" onClick={() => reset()}>Reset</Button>
                                                    <Button type='submit' className="btn btn-warning btn-lg ms-2 sap-btn-dark">Submit</Button>
                                                    </div>

                                                </div>
                                            </Form>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </main>
                </div>
            </div>
        </>
    )
};

const AdminLogout = () => {
    const childRef = useRef(null);
    useEffect(() => {
        childRef.current.logout('admin');
    }, []);

    return (
        <Child ref={childRef} />
    )
}

// const AdminLogout = () => {
//     const navigate = useNavigate();

//     useEffect(() => {
//         const loggedInUser = localStorage.getItem("user-token");
//         if (loggedInUser) {
//             localStorage.clear();
//             toast.success("Admin logged out")
//             navigate("/admin");
//         }
//     }, []);
// }

export {AdminLogin, AdminLogout};